const SearchIcon = ({ height = '16', width = '16', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio={'xMinYMin meet'}
    height={height}
    width={width}
    {...props}
  >
    <g fill="currentColor" fillRule="evenodd">
      <path
        d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z"
        fillRule="nonzero"
      />
      <path d="M15.707 14.293L13.314 11.9a8.019 8.019 0 0 1-1.414 1.414l2.393 2.393a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414z" />
    </g>
  </svg>
)

export default SearchIcon
